import { useContext } from "react";
import { VerificationContext } from "../../contexts/VerificationContext";

const useVerify = () => {
  return useContext(VerificationContext);
};
export default useVerify;
